import { toDayIndex } from './day';

const BANGKOK_DATE = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Bangkok',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

export function bangkokBusinessDay(now: Date = new Date()): number {
  const parts = BANGKOK_DATE.formatToParts(now);
  const valueOf = (type: Intl.DateTimeFormatPartTypes): number => {
    const value = parts.find((part) => part.type === type)?.value;
    if (!value) throw new Error(`Missing Bangkok date part: ${type}`);
    return Number(value);
  };
  return toDayIndex(
    Date.UTC(valueOf('year'), valueOf('month') - 1, valueOf('day')),
  );
}
